import * as LessonsV3 from '../../../model/v3/lessons';
import {CourseDefUtils} from './course-def';

export class ProgressEstimationUtils {
  static estimateNextProgress(
    current: LessonsV3.LessonProgressDetails | null | undefined,
    productCode?: string | null,
    productVersion?: string | null,
  ): LessonsV3.LessonCallanProgressDetailsDto | null {
    if (!current || !productCode) {
      return null;
    }

    const actualVersion = productVersion ?? current.productVersion ?? null;
    const start = current.start ?? 1;
    const nwp = current.nwp ?? (start + 2);
    const estimatedStart = current.start == null ? start : nwp;
    const estimatedNwp = estimatedStart + 2;
    const course = CourseDefUtils.findForPage(productCode, estimatedNwp, actualVersion);

    if (!course) {
      return null;
    }

    return {
      '@type': 'callan',
      start: estimatedStart,
      reading: current.reading ?? 0,
      nwp: estimatedNwp,
      headwords: current.headwords ?? '',
      productVersion: actualVersion,
    };
  }
}
